import script from "./TheProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./TheProducts.vue?vue&type=script&setup=true&lang=js"

import "./TheProducts.vue?vue&type=style&index=0&id=6495fa94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6495fa94"]])

export default __exports__